<h2 class="text-left">Setup Email MFA</h2>
<div class="setup-mfa">
  <mat-card>
    <mat-card-title>
      Step 1
    </mat-card-title>
    Request email with the code.
    <div class="button">
      <button (click)="init()" mat-raised-button>Request</button>
    </div>
  </mat-card>
  <mat-card>
    <mat-card-title>
      Step 3
    </mat-card-title>
    Enter the code from the email.
    <mat-form-field>
      <input [(ngModel)]="code" matInput type="password">
    </mat-form-field>
    <div class="button">
      <button (click)="submit()" mat-raised-button>Submit</button>
    </div>
  </mat-card>
</div>
